import removeExoPrefixIfNeeded from './removeExoPrefixIfNeeded';
import safeGetPathname from './safeGetPathname';

export default (currentProject, productIdToUse) => {
  const pathname = removeExoPrefixIfNeeded(window.location.pathname);

  const product = currentProject?.products?.find(
    (p) => p.key === productIdToUse,
  );
  const tool = product?.tools?.find(
    (t) => t.url && pathname.startsWith(safeGetPathname(t.url)),
  );
  return tool?.key;
};
